import { DatePicker, DatePickerProps } from "@mui/x-date-pickers/DatePicker";
import { Moment } from "moment";
import { useEffect, useRef, useState } from "react";

interface MaturityPickerProps extends DatePickerProps {
  firstCouponDate: Moment;
  onChange: (value: Moment) => void
}

export default function MaturityPicker({
  firstCouponDate,
  ...props
}: MaturityPickerProps) {
  const [lastSetValue, setLastSetValue] = useState<Moment>(props.value.clone());
  const [inputValue, setInputValue] = useState<Moment>(props.value.clone());
  const pickerRef = useRef<HTMLInputElement | null>(null);
  const isInputValid = isDateValid(inputValue);

  useEffect(() => {
    const propDate: Moment = props.value;
    if (!propDate.isSame(inputValue, "day")) {
      setInputValue(propDate);
    }
  }, [props.value]);

  function isDateValid(date: Moment) {
    if (!date) return false;
    const monthsDiff = date.startOf("day").diff(firstCouponDate.startOf("day"), "months", true);
    if (monthsDiff % 6 !== 0) return false;
    const beforeFirstCoupon = date.startOf("day").isBefore(firstCouponDate.startOf("day"));
    if (beforeFirstCoupon) return false;
    return true;
  };

  function updateOrReset() {
    if (isInputValid) {
      setLastSetValue(inputValue.clone());
      props.onChange(inputValue.clone());
    } else {
      setInputValue(lastSetValue)
    }
  }

  return (
    <DatePicker
      {...props}
      ref={pickerRef}
      value={inputValue}
      onChange={(val) => {
        setInputValue(val);
      }}
      onClose={() => {
        updateOrReset();
      }}
      slotProps={{
        ...props.slotProps,
        textField: {
          ...props.slotProps?.textField,
          size: 'small',
          placeholder: 'MM/DD/YYYY',
          sx: { 
            width: '175px',
            '& .MuiInputBase-root': {
              height: '40px'
            },
            ...(!isInputValid && {
              '& fieldset': {
                border: "1px solid red !important"
              },
            }),
          },
          onBlur: (e: any) => {
            const isInsidePicker = pickerRef.current && pickerRef.current.contains(e.relatedTarget) && !(e.relatedTarget instanceof HTMLButtonElement);
            if (isInsidePicker) return;
            updateOrReset();
          }
        }
      }}
    />
  );
}
